import { ConsentStore } from './consent-store';

let activeObserver: MutationObserver | null = null;

export function initCookieEnforcer(): void {
  if (activeObserver) return; // idempotent: one observer per document

  blockExistingTaggedScripts();

  activeObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of Array.from(mutation.addedNodes)) {
        if (node instanceof HTMLScriptElement) {
          const category = node.getAttribute('data-consent-category');
          if (category && !ConsentStore.hasConsentForCategory(category)) {
            node.type = 'text/plain';
            node.setAttribute('data-blocked', 'true');
          }
        }
      }
    }
  });

  activeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

export function teardownCookieEnforcer(): void {
  if (!activeObserver) return;
  activeObserver.disconnect();
  activeObserver = null;
}

function blockExistingTaggedScripts() {
  const scripts = document.querySelectorAll('script[data-consent-category]');
  scripts.forEach(el => {
    if (el instanceof HTMLScriptElement) {
      const category = el.getAttribute('data-consent-category');
      if (category && !ConsentStore.hasConsentForCategory(category) && el.type !== 'text/plain') {
        el.type = 'text/plain';
        el.setAttribute('data-blocked', 'true');
      }
    }
  });
}

export function manageCookies(consentData: { accepted: boolean, categories: string[] }) {
  const blockedScripts = document.querySelectorAll('script[data-blocked="true"]');
  blockedScripts.forEach(oldScript => {
    if (oldScript instanceof HTMLScriptElement) {
      const category = oldScript.getAttribute('data-consent-category');
      if (category && consentData.categories.includes(category)) {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => {
          if (attr.name !== 'type' && attr.name !== 'data-blocked') {
            newScript.setAttribute(attr.name, attr.value);
          }
        });
        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      }
    }
  });
}
